import React, { useState } from "react";
import {
  TextField,
  IconButton,
  InputAdornment,
  Button,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  animatedButton: {
    background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
    color: "#fff",
    padding: "10px 30px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "5px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
    },
  },
});

const Notification = () => {
  const classes = useStyles();
  const [iconActive, setIconActive] = useState(false);

  const handleIconToggle = () => {
    setIconActive((prev) => !prev);
  };

  return (
    <>
      <Stack style={{ marginTop: "30px" }}>
        <Typography variant="subtitle1">Manage Notification</Typography>
      </Stack>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={4}>
          <TextField
            fullWidth
            label="Mobile Number"
            type="text"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleIconToggle}
                    edge="end"
                    sx={{
                      color: iconActive ? "green" : "inherit",
                    }}
                  >
                    <WhatsAppIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <TextField fullWidth label="Email" type="text" />
        </Grid>
        <Grid item xs={12}>
          <Grid container justifyContent="flex-end">
            <Button
              type="submit"
              variant="contained"
              className={classes.animatedButton}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Notification;
